module.exports = __webpack_public_path__ + "static/assets/51c02cfb6660f600c57c6002368b1088.svg";